var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',[(_vm.config.ShowPath)?_c('span',[_vm._v(_vm._s(_vm.value))]):_vm._e(),(!_vm.config.NoDownload)?_c('a',{attrs:{"href":_vm.$matrix.config.ImageSite + _vm.value,"target":"_blank","download":"下载文件"}},[_vm._v("下载")]):_vm._e()]):_c('div',[_vm._v("未上传"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }